export function ourStorySlider() {
    const sliderHolder = $(".our-story-slider-holder");
    sliderHolder.each(function () {
        const $this = $(this);
        const $slider = $this.find(".our-story-slider");
        const $sliderNav = $this.find(".our-story-slider-nav .item");
        $slider.on('init', function () {
            $sliderNav.eq(0).addClass("active");
        });
        $slider.slick({
            infinite: false,
            arrows: true,
            prevArrow: "<button class='slick-prev'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" fill=\"currentColor\" class=\"bi bi-arrow-left-short\" viewBox=\"0 0 16 16\"> <path fill-rule=\"evenodd\" d=\"M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z\"/> </svg></button>",
            nextArrow:"<button class='slick-next'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" fill=\"currentColor\" class=\"bi bi-arrow-right-short\" viewBox=\"0 0 16 16\"> <path fill-rule=\"evenodd\" d=\"M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z\"/> </svg></button>",
            dots: false,
            mobileFirst: true,
            speed: 600,
            slidesToShow: 1.1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: true,
                    }
                },
            ]
        });
        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $sliderNav.removeClass("active").eq(nextSlide).addClass("active");
        });
        $sliderNav.on("click", function (e) {
            e.preventDefault();
            let index = $(this).index();
            $slider.slick('slickGoTo', index);
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/our-story-slider.js